import classNames from 'classnames'
import { MdDelete } from 'react-icons/md'

import type { ReactElement, ReactNode } from 'react'

import Button from '~/components/Buttons/Button'
import Modal from '~/components/Modal'
import { ModalBody, ModalFooter } from '~/components/Modal/Layout'

import './styles.scss'

export interface Props {
  btnCancel?: ReactNode
  btnConfirm?: ReactNode
  className?: string
  icon?: ReactNode
  isLoading?: boolean
  isOpen: boolean
  mainText: string
  onClose: VoidFunction
  onConfirm: VoidFunction
  shouldCloseOnOverlayClick?: boolean
  subText?: string
}

const ModalDialog = ({
  btnCancel,
  btnConfirm,
  className,
  icon,
  isLoading,
  isOpen,
  mainText,
  onClose,
  onConfirm,
  shouldCloseOnOverlayClick = true,
  subText,
}: Props): ReactElement => {
  return (
    <Modal
      className={classNames('modal-dialog-component', className)}
      isOpen={isOpen}
      onCloseModal={onClose}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    >
      <ModalBody>
        <div className="modal-dialog-component__body">
          {icon || <MdDelete color="#aeaeae" size={65} />}
          <span className="modal-dialog-component__body__title">{mainText}</span>
          {subText ? <span className="modal-dialog-component__body__subtext">{subText}</span> : <div></div>}
        </div>
      </ModalBody>
      <ModalFooter>
        {btnCancel ? (
          btnCancel
        ) : (
          <Button disabled={isLoading} ghost onClick={onClose}>
            Cancel
          </Button>
        )}
        {btnConfirm ? (
          btnConfirm
        ) : (
          <Button disabled={isLoading} onClick={onConfirm}>
            Delete
          </Button>
        )}
      </ModalFooter>
    </Modal>
  )
}

export default ModalDialog
